import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#5D8791", d: "M9.903 7h5.029c0-2.762-2.253-5-5.029-5A5 5 0 0 0 4.89 7c0 2.76 2.252 4.999 5.013 4.999z" }), /* @__PURE__ */ React.createElement("path", { fill: "#E95517", d: "M10.877 13H5.848c0 2.762 2.253 5 5.029 5a5 5 0 0 0 5.014-5c0-2.76-2.253-4.998-5.014-4.998z" }));
const SvgSeismicDarkmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgSeismicDarkmode;
